import { chartColorAndroid, chartColorMac, chartColorMain, chartColorMobileVR } from '../../../shared/chart/chart-color'

// The words and numbers of the Launches tab.

// The six outcomes of a launch, with the plan's labels. The first four are
// sessions that completed (counted on the day they completed); the last two
// are launches that failed (counted on the day they were made). "Not passed"
// is a learner who finished below the pass mark; "Didn't start" is a launch
// that never began a session. They are never one number.
export const COMPLETED_OUTCOMES = [
  { key: 'passed', label: 'Passed' },
  { key: 'notPassed', label: 'Not passed' },
  { key: 'completedNoMark', label: 'Completed (no pass mark)' },
  { key: 'endedUnfinished', label: 'Ended unfinished' }
]

export const FAILED_OUTCOMES = [
  { key: 'didntStart', label: "Didn't start" },
  { key: 'endedEarly', label: 'Session ended early' }
]

export const OUTCOMES = [...COMPLETED_OUTCOMES, ...FAILED_OUTCOMES]

// Where a refusal was recorded (the service's source names), in plain words:
// at the course package's launch page, when the launch was started, in an LTI
// launch, or only counted (rate limited, unknown intent).
export const SOURCE_TEXT = {
  bootstrap: 'Course package',
  mint: 'Launch start',
  lti: 'LTI launch',
  counted: 'Counted only'
}

export const TRUNCATED_TEXT = 'Showing the first 1,000 rows.'

export const UNKNOWN = '—'

// Orders numbers, an unknown one (null) before any number.
export const numericComparator = (a, b) => {
  const x = typeof a === 'number' ? a : Number.NEGATIVE_INFINITY
  const y = typeof b === 'number' ? b : Number.NEGATIVE_INFINITY
  if (x === y) return 0
  return x < y ? -1 : 1
}

export const formatCount = value => (typeof value === 'number' ? value.toLocaleString('en-US') : UNKNOWN)

// A column's number as the tiles write it (1,234): the grids' selector for a
// count. One function per field, so a grid's cells keep their renderer.
const countSelectors = {}
export const countText = field => {
  if (!countSelectors[field]) countSelectors[field] = row => formatCount(row[field])
  return countSelectors[field]
}

// An average or a median: up to two decimals, a dash where there is no score.
export const formatScore = value => (typeof value === 'number' ? value.toLocaleString('en-US', { maximumFractionDigits: 2 }) : UNKNOWN)

// The 10-point score buckets: [0,10) ... [80,90) and [90,100].
export const SCORE_LABELS = ['0–10', '10–20', '20–30', '30–40', '40–50', '50–60', '60–70', '70–80', '80–90', '90–100']

// A bucket's label: the day it starts, as the date pickers write it. The
// bucketStart is RFC 3339 with the zone's offset, so its own date is the day
// in the chosen zone.
export const bucketLabel = bucketStart => {
  const text = String(bucketStart || '')
  return /^\d{4}-\d{2}-\d{2}/.test(text) ? `${text.slice(5, 7)}/${text.slice(8, 10)}/${text.slice(0, 4)}` : text
}

export const connectionText = row => (row.connectionName ? (row.connectionArchived ? `${row.connectionName} (archived)` : row.connectionName) : UNKNOWN)

// The charts' colours (shared/chart/chart-color.js); what lies before the
// retention cutoff is drawn grey.
export const COLOR_LAUNCHES = chartColorMac
export const COLOR_COMPLETIONS = chartColorAndroid
export const COLOR_REFUSALS = chartColorMobileVR
export const COLOR_SCORES = chartColorMain
export const COLOR_GREYED = '#C4C9D2'
